import { BrandCode, TenantCode } from "../../models/brand";
import { BRAND_MAP } from "./constants";
import { SERVICE_CODE } from "../common/contants";

export function getBrandByCode(code: BrandCode) {
  const brand = BRAND_MAP[code];
  if (brand) {
    return brand;
  }
  throw new Error(`Cannot find entry for brand with id ${code}`);
}

export function getTenantCodeByBrandCode(code: BrandCode) {
  const brand = getBrandByCode(code);
  if (brand.kind === "Tenant") {
    return brand.code;
  }
  throw new Error(`Brand ${code} is a non-Tenant brand`);
}

export function getServiceCodeByTenant(tenant: TenantCode | undefined) {
  return tenant === BRAND_MAP.GF.code ? SERVICE_CODE.VPN : SERVICE_CODE.USENET;
}
